import type { ReactElement } from 'react';
import cx from 'clsx';
import type { PressEvent } from 'react-aria-components';
import { Button } from '#components/button/button';
import {
  IconCheckmarkRoundedFilled,
  IconCrossOutlined,
  IconCrossRoundedFilledSmall,
  IconInfoRoundedFilled,
} from '@repo/monochrome-icons';
import styles from './toast.module.css';

export { useToast } from './provider/use-toast';
export { ToastRegion } from './provider/toast-region';
export { clearToastQueue } from './provider/toast-queue';

interface ToastProps {
  type?: 'info' | 'success' | 'error';
  text: string;
  onClose: (e: PressEvent) => void;
  closeButtonAriaLabel?: string;
  className?: string;
}

export function Toast({
  type = 'info',
  text,
  onClose,
  closeButtonAriaLabel = 'Close',
  className,
}: ToastProps): ReactElement {
  return (
    <div
      className={cx(styles.toast, styles[type], className)}
      data-test-toast
      data-test-type={type}
    >
      <div className={styles.iconContainer}>
        {type === 'info' && <IconInfoRoundedFilled className={styles.icon} />}
        {type === 'success' && <IconCheckmarkRoundedFilled className={styles.icon} />}
        {type === 'error' && <IconCrossRoundedFilledSmall className={styles.icon} />}
      </div>
      <p className={cx('body-standard', styles.text)}>{text}</p>
      <Button
        aria-label={closeButtonAriaLabel}
        className={styles.close}
        iconOnly
        onPress={onClose}
        size="small"
        variant="tertiary"
      >
        <IconCrossOutlined />
      </Button>
    </div>
  );
}
